import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('settings', {
    state: () => {
        return {
            settings:           window.OptimizeTemplates,
            hasWorkflows:       window.OptimizeTemplates.has_workflows,
            workflowCount:      window.OptimizeTemplates.workflow_count,
            slIsConnected:      window.OptimizeTemplates.sl_is_connected,
            slLicenseIsValid:   window.OptimizeTemplates.sl_license_is_valid,
            maxLogItems:        window.OptimizeTemplates.max_log_items,
            ajaxUrl:            window.OptimizeTemplates.ajax_url,
            restUrl:            window.OptimizeTemplates.rest_url,
            assetsUrl:          window.OptimizeTemplates.assets_url,
            imgUrl:             window.OptimizeTemplates.img_url,
            config:             window.OptimizeTemplates.config,
            developer:          window.OptimizeTemplates.sl_role === 'admin',
            builderEnabled:     window.OptimizeTemplates.builder_is_enabled,
            debug:              window.OptimizeTemplates.debug,
        }
    },
    actions: {

    }
})
